import { render } from "./ShowItem.vue?vue&type=template&id=2f36363c"
import script from "./ShowItem.vue?vue&type=script&lang=js"
export * from "./ShowItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__